type ListIconProps = {
  className?: string;
  fill?: string;
};

const ListIcon = ({ className, fill }: ListIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7 3.50051V6.49949L4.50099 8L2 6.49949V3.50051L4.50099 2L7 3.50051Z"
      fill={fill}
    />
    <rect x="9" y="4" width="13" height="2" rx="1" fill={fill} />
    <path
      d="M7 10.5005V13.4995L4.50099 15L2 13.4995V10.5005L4.50099 9L7 10.5005Z"
      fill={fill}
    />
    <rect x="9" y="11" width="13" height="2" rx="1" fill={fill} />
    <path
      d="M7 17.5005V20.4995L4.50099 22L2 20.4995V17.5005L4.50099 16L7 17.5005Z"
      fill={fill}
    />
    <rect x="9" y="18" width="13" height="2" rx="1" fill={fill} />
    <path
      d="M7 3.50051V6.49949L4.50099 8L2 6.49949V3.50051L4.50099 2L7 3.50051Z"
      fill={fill}
    />
    <rect x="9" y="4" width="13" height="2" rx="1" fill={fill} />
  </svg>
);

export default ListIcon;
